module.exports = __webpack_public_path__ + "img/function07.1c2cf3e8.png";